export enum MedicationStatusEnum {
  ACTIVE = "active",
  DISCONTINUED = "discontinued",
  SKIPPED = "skipped",
}
